<template>
  <div class="discount-rules responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        :pageHeader="listPageHeader"
        :links="[
          { name: 'home', label: 'Home' },
          { name: 'discountRules', label: 'Discount Rules' },
        ]"
        :entity="entity"
      >
        <BaseBtn
          v-if="currentStore._id"
          label="Discount Settings"
          iconGroup="fas"
          iconName="cog"
          :colorType="6"
          @click="goToStoreSettings"
        />
      </PageHeader>
      <SearchTable
        :entity="entity"
        :sort="sort"
        :selectedFilter="selectedFilter"
        @selectedFilterChange="setSelectedFilter"
        @sortChangeEvent="updateSort"
        :pagination="pagination"
        @paginationChange="updatePagination"
        @initialFilterUpdate="updateInitialFilter"
        :initialFilter="initialFilter"
        :isLoading="isLoading"
        :filterButtons="filterButtons"
        @filterButtonsChange="updateFilterButtons"
      />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import { listPageHeader } from "./inputs";
import SearchTable from "@/components/SearchTable.vue";
import Entities from "@/resources/Entities";
import { mapActions, mapGetters } from "vuex";
import BaseBtn from "@/components/Base/Button/Button.vue";

export default {
  name: "discountRules",
  data() {
    return {
      listPageHeader,
      entity: Entities.DISCOUNTRULE,
    };
  },
  mounted: function () {
    this.setPageTitle("Discount Rules");
  },
  components: {
    PageHeader,
    SearchTable,
    BaseBtn,
  },
  computed: {
    ...mapGetters({
      sort: "discountRuleModule/sort",
      pagination: "discountRuleModule/pagination",
      initialFilter: "discountRuleModule/initialFilter",
      loadingStatus: "discountRuleModule/loadingStatus",
      selectedFilter: "discountRuleModule/selectedFilter",
      currentStore: "storeModule/currentStore",
      filterButtons: "discountRuleModule/filterButtons",
    }),
    isLoading() {
      return this.loadingStatus.getDiscountRules;
    },
  },
  methods: {
    ...mapActions({
      updateSort: "discountRuleModule/updateSort",
      updatePagination: "discountRuleModule/updatePagination",
      updateInitialFilter: "discountRuleModule/updateInitialFilter",
      setSelectedFilter: "discountRuleModule/setSelectedFilter",
      updateFilterButtons: "discountRuleModule/updateFilterButtons",
    }),
    goToStoreSettings() {
      this.$router.push({
        name: 'storeEditor',
        query: {
          id: this.currentStore._id,
          section: 'discountEngine'
        }
      });
    },
  }
};
</script>

